module.exports = __webpack_public_path__ + "static/media/double-standard-img7.98e00e70.jpg";